import React, { Suspense } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toast } from "react-toastify";
import moment from "moment";
import { Button } from "react-bootstrap";
import ReactTable from "react-table";
import AccountingExportHeader from "./accounting-export-header";
import { closeCustomModal, openCustomModal } from "../../../custom/modals";
import Spinner from "../../../common/Spinner";
import ServiceInvoicesModal from "./service-invoices-modal";
import {
    exportAccountingServiceInvoices,
    fetchAccountingServiceInvoices,
    exportAccountingReportExcel
} from "../../../../api/menu/invoicing/actions";

import filterCaseInsensitive from "../../../custom/forms/react-table-case-insensitive";
import CustomCheckbox from "../../../custom/forms/custom-checkbox";

class ServiceInvoicesList extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            batchNumber: 0,
            selectedServiceInvoices: [],
            postedDate: moment()
        };

        this.handleLoadServiceInvoices = this.handleLoadServiceInvoices.bind(this);
        this.handleExportServiceInvoices = this.handleExportServiceInvoices.bind(this);
        this.setBatchNumber = this.setBatchNumber.bind(this);
        this.setSelectedServiceInvoices = this.setSelectedServiceInvoices.bind(this);
        this.handleBatchReport = this.handleBatchReport.bind(this);
        this.modalOpen = this.modalOpen.bind(this);
    }

    componentDidMount() {
        this.handleLoadServiceInvoices();
    }

    handleLoadServiceInvoices() {
        this.props.fetchAccountingServiceInvoices(this.state.batchNumber);
    }

    handleExportServiceInvoices() {
        const { selectedServiceInvoices, postedDate } = this.state;

        const requestBody = {
            invoiceIds: selectedServiceInvoices,
            postedDate
        };

        this.props.exportAccountingServiceInvoices(requestBody, this.handleLoadServiceInvoices);
    }

    modalOpen = () => {
        const modalObj = {
            id: "posting",
            modalSettings: {
                size: "sm"
            },
            header: "Enter Posting Date",
            children: (
                <Suspense
                    fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ServiceInvoicesModal
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        handleExport={this.handleExportServiceInvoices}
                    />
                </Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    setBatchNumber(batch) {
        this.setState({
            batchNumber: batch.value
        });
    }

    handleBatchReport() {
        const { batchNumber } = this.state;

        this.props.exportAccountingReportExcel(batchNumber);
    }

    setSelectedServiceInvoices(id) {
        const selectedInvoices = Object.assign([], this.state.selectedServiceInvoices);

        const index = selectedInvoices.indexOf(id);

        if (index >= 0) {
            selectedInvoices.splice(index, 1);
        } else {
            selectedInvoices.push(id);
        }

        this.setState({
            selectedServiceInvoices: selectedInvoices
        });
    }

    onToggle = () => {
        const { selectedServiceInvoices } = this.state;
        const { accountingExportServiceInvoices } = this.props;

        const selectedInvoices =
            selectedServiceInvoices.length === accountingExportServiceInvoices.length ?
                [] : accountingExportServiceInvoices.map(i => i.invoiceId);

        this.setState({
            selectedServiceInvoices: selectedInvoices
        });
    };

    getColumns = () => {
        const { selectedServiceInvoices } = this.state;
        const { accountingExportServiceInvoices } = this.props;

        const columns = [];

        columns.push({
            Cell: ({ original }) => (
                <CustomCheckbox
                    key={original.invoiceId}
                    className="checkbox"
                    checked={selectedServiceInvoices.includes(original.invoiceId)}
                    onChange={() => this.setSelectedServiceInvoices(original.invoiceId)}
                />
            ),
            headerClassName: "text-left",
            Header: () => (
                <input
                    type="checkbox"
                    className="checkbox"
                    checked={selectedServiceInvoices.length ? selectedServiceInvoices.length ===
                        accountingExportServiceInvoices.length : false}
                    onChange={() => this.onToggle()}
                />
            ),
            sortable: false,
            filterable: false,
            resizable: false,
            minResizeWidth: 40,
            width: 40,
            className: "d-flex"
        });
        columns.push({
            Header: "Invoice Number",
            headerClassName: "text-left",
            accessor: "invoiceNum"
        });
        columns.push({
            id: "date",
            Header: "Date",
            headerClassName: "text-left",
            accessor: original => moment(original.dateIssued).format(this.dateFormat)
        });
        columns.push({
            Header: "Merchandiser",
            headerClassName: "text-left",
            accessor: "empFullname"
        });
        columns.push({
            Header: "Amount",
            headerClassName: "text-left",
            accessor: "amount"
        });
        columns.push({
            Header: "Batch Number",
            headerClassName: "text-left",
            accessor: "batchNum"
        });

        return columns;
    };

    render() {
        const { selectedServiceInvoices } = this.state;
        const { accountingExportServiceInvoices } = this.props;

        const selectedText = accountingExportServiceInvoices.length ?
            `Selected ${selectedServiceInvoices.length} out of ${accountingExportServiceInvoices.length} invoices` : "";

        return (
            <div className="dashboard">
                <div className="position-relative">
                    {!this.props.loading || <Spinner/>}

                    <AccountingExportHeader
                        handleLoad={this.handleLoadServiceInvoices}
                        batches={this.props.batches}
                        batchNumber={this.state.batchNumber}
                        setBatchNumber={this.setBatchNumber}
                        selectedText={selectedText}
                    />
                    <div className="mb-4">
                        <ReactTable
                            data={accountingExportServiceInvoices}
                            columns={this.getColumns()}
                            headerClassName="table-header"
                            showPagination={false}
                            pageSize={Math.max(accountingExportServiceInvoices.length, 20)}
                            resizable
                            className="-striped -highlight"
                            filterable={false}
                            defaultFilterMethod={filterCaseInsensitive}
                            getNoDataProps={() => ({
                                style: {
                                    zIndex: 0
                                }
                            })}
                            style={{
                                height: "calc(100vh - 270px)",
                            }}
                        />
                    </div>
                </div>
                <div className="mt-4 mb-4 text-left">
                    <Button
                        disabled={!selectedServiceInvoices.length}
                        className="ml-2"
                        variant="primary"
                        onClick={() => this.modalOpen()}
                    >
                        Export Selection
                    </Button>
                    <Button
                        className="ml-2"
                        variant="success"
                        onClick={this.handleBatchReport}
                    >
                        Batch Report
                    </Button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.invoicing.loading,
    exportedData: state.invoicing.exportedData,

    accountingExportServiceInvoices: state.invoicing.accountingExportServiceInvoices,
});

const mapStateToDispatch = dispatch => ({
    fetchAccountingServiceInvoices: bindActionCreators(fetchAccountingServiceInvoices, dispatch),
    exportAccountingServiceInvoices: bindActionCreators(exportAccountingServiceInvoices, dispatch),
    exportAccountingReportExcel: bindActionCreators(exportAccountingReportExcel, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ServiceInvoicesList);
